export default {
  header: {
    signIn: 'Log Masuk',
    signUp: 'Daftar'
  },
  userMenu: {
    wallet: 'Dompet',
    withdraw: 'Pengeluaran',
    transaction: 'Transaksi',
    myBet: 'Pertaruhan Saya',
    rollover: 'Rollover',
    vault: 'Peti Besi',
    profile: 'Profil',
    settings: 'Tetapan',
    signOut: 'Log Keluar',
    signOutTitle: 'Log keluar',
    signOutContent: 'Terokai dunia yang penuh dengan ganjaran dan permainan yang menarik!',
    signOutConfirm: 'Log keluar',
    cancel: 'Batal'
  }
};
